// extracted by mini-css-extract-plugin
export var bodySections = "_6f-8";
export var gray = "_6f-7";
export var green = "_6f-4";
export var iconContainer = "_6f-9";
export var iconWidgetContainer = "_6f-1";
export var phoneIcon = "_6f-2";
export var red = "_6f-5";
export var statusDot = "_6f-3";
export var widgetContainer = "_6f-0";
export var yellow = "_6f-6";